(function () {
  function initTabShowcase(section) {
    if (!section) return;

    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const tabs = Array.from(
      section.querySelectorAll('[data-showcase-tab]')
    );

    const panels = Array.from(
      section.querySelectorAll('[data-showcase-panel]')
    );

    const mobilePagination = section.querySelector(
      '[data-mobile-pagination]'
    );

    const mobileDots = Array.from(
      section.querySelectorAll('[data-mobile-dot]')
    );

    const mobileCurrent = section.querySelector(
      '[data-mobile-current]'
    );

    const mobileTotal = section.querySelector(
      '[data-mobile-total]'
    );

    const panelsContainer = section.querySelector(
      '.tab-showcase__panels'
    );

    const mobileMedia = window.matchMedia(
      '(max-width: 749px)'
    );

    let activeIndex = 0;
    let imageTimers = [];
    let scrollTimer = null;

    let imageInterval = parseInt(
      section.dataset.imageInterval,
      10
    );

    if (
      Number.isNaN(imageInterval) ||
      imageInterval < 1
    ) {
      imageInterval = 4;
    }

    imageInterval = imageInterval * 1000;

    function clearImageTimers() {
      imageTimers.forEach(function (timer) {
        window.clearInterval(timer);
      });

      imageTimers = [];
    }

    function initializeImageRotations() {
      clearImageTimers();

      panels.forEach(function (panel) {
        const frame = panel.querySelector(
          '[data-image-frame]'
        );

        if (!frame) return;

        const slides = Array.from(
          frame.querySelectorAll(
            '[data-image-slide]'
          )
        );

        if (!slides.length) return;

        slides.forEach(function (slide, index) {
          slide.classList.toggle(
            'is-active',
            index === 0
          );
        });

        if (slides.length <= 1) return;

        let imageIndex = 0;

        const timer = window.setInterval(
          function () {
            imageIndex =
              (imageIndex + 1) %
              slides.length;

            slides.forEach(
              function (slide, index) {
                slide.classList.toggle(
                  'is-active',
                  index === imageIndex
                );
              }
            );
          },
          imageInterval
        );

        imageTimers.push(timer);
      });
    }

    function resetPanelImages(panel) {
      if (!panel) return;

      const slides = Array.from(
        panel.querySelectorAll(
          '[data-image-slide]'
        )
      );

      if (!slides.length) return;

      slides.forEach(function (
        slide,
        index
      ) {
        slide.classList.toggle(
          'is-active',
          index === 0
        );
      });
    }

    function updateMobileIndicator(index) {
      if (!panels.length) return;

      const safeIndex = Math.max(
        0,
        Math.min(
          index,
          panels.length - 1
        )
      );

      activeIndex = safeIndex;

      if (mobileCurrent) {
        mobileCurrent.textContent =
          safeIndex + 1;
      }

      if (mobileTotal) {
        mobileTotal.textContent =
          panels.length;
      }

      mobileDots.forEach(function (
        dot,
        dotIndex
      ) {
        const isActive =
          dotIndex === safeIndex;

        dot.classList.toggle(
          'is-active',
          isActive
        );

        dot.setAttribute(
          'aria-current',
          isActive
            ? 'true'
            : 'false'
        );
      });
    }

    function activateDesktopTab(index) {
      if (!tabs.length || !panels.length) {
        return;
      }

      if (
        index < 0 ||
        index >= panels.length
      ) {
        return;
      }

      activeIndex = index;

      tabs.forEach(function (
        tab,
        tabIndex
      ) {
        const isActive =
          tabIndex === index;

        tab.classList.toggle(
          'is-active',
          isActive
        );

        tab.setAttribute(
          'aria-selected',
          isActive
            ? 'true'
            : 'false'
        );

        tab.setAttribute(
          'tabindex',
          isActive
            ? '0'
            : '-1'
        );
      });

      panels.forEach(function (
        panel,
        panelIndex
      ) {
        const isActive =
          panelIndex === index;

        panel.classList.toggle(
          'is-active',
          isActive
        );

        panel.classList.remove(
          'is-entering'
        );

        if (isActive) {
          resetPanelImages(panel);

          window.requestAnimationFrame(
            function () {
              window.requestAnimationFrame(
                function () {
                  panel.classList.add(
                    'is-entering'
                  );
                }
              );
            }
          );
        }
      });

      updateMobileIndicator(index);
    }

    function scrollToMobilePanel(index) {
      if (
        !panels.length ||
        index < 0 ||
        index >= panels.length
      ) {
        return;
      }

      const panel = panels[index];

      if (!panel) return;

      activeIndex = index;

      panel.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });

      updateMobileIndicator(index);
    }

    function getClosestMobilePanel() {
      if (
        !panelsContainer ||
        !panels.length
      ) {
        return 0;
      }

      const containerRect =
        panelsContainer.getBoundingClientRect();

      let closestIndex = 0;
      let closestDistance = Infinity;

      panels.forEach(function (
        panel,
        index
      ) {
        const panelRect =
          panel.getBoundingClientRect();

        const distance = Math.abs(
          panelRect.left -
          containerRect.left
        );

        if (
          distance < closestDistance
        ) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function handleMobileScroll() {
      if (!mobileMedia.matches) return;

      if (scrollTimer) {
        window.clearTimeout(
          scrollTimer
        );
      }

      scrollTimer =
        window.setTimeout(
          function () {
            const index =
              getClosestMobilePanel();

            updateMobileIndicator(index);
          },
          80
        );
    }

    function syncMode() {
      if (mobileMedia.matches) {
        panels.forEach(function (
          panel
        ) {
          panel.classList.add(
            'is-active'
          );

          panel.classList.remove(
            'is-entering'
          );
        });

        updateMobileIndicator(
          activeIndex
        );

        window.requestAnimationFrame(
          function () {
            if (
              panelsContainer &&
              panels[activeIndex]
            ) {
              panelsContainer.scrollLeft =
                panels[activeIndex]
                  .offsetLeft;
            }
          }
        );
      } else {
        activateDesktopTab(
          activeIndex
        );
      }
    }

    tabs.forEach(function (
      tab,
      index
    ) {
      tab.addEventListener(
        'click',
        function () {
          activateDesktopTab(
            index
          );
        }
      );

      tab.addEventListener(
        'keydown',
        function (event) {
          let newIndex = index;

          if (
            event.key ===
            'ArrowRight'
          ) {
            newIndex =
              (index + 1) %
              tabs.length;
          } else if (
            event.key ===
            'ArrowLeft'
          ) {
            newIndex =
              (index - 1 +
                tabs.length) %
              tabs.length;
          } else if (
            event.key === 'Home'
          ) {
            newIndex = 0;
          } else if (
            event.key === 'End'
          ) {
            newIndex =
              tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();

          activateDesktopTab(
            newIndex
          );

          if (tabs[newIndex]) {
            tabs[newIndex].focus();
          }
        }
      );
    });

    mobileDots.forEach(function (
      dot
    ) {
      dot.addEventListener(
        'click',
        function () {
          const slideIndex =
            parseInt(
              dot.dataset.slideIndex,
              10
            );

          if (
            Number.isNaN(
              slideIndex
            )
          ) {
            return;
          }

          scrollToMobilePanel(
            slideIndex
          );
        }
      );
    });

    if (panelsContainer) {
      panelsContainer.addEventListener(
        'scroll',
        handleMobileScroll,
        {
          passive: true
        }
      );
    }

    if (
      typeof mobileMedia
        .addEventListener ===
      'function'
    ) {
      mobileMedia.addEventListener(
        'change',
        syncMode
      );
    } else if (
      typeof mobileMedia
        .addListener ===
      'function'
    ) {
      mobileMedia.addListener(
        syncMode
      );
    }

    if (mobilePagination) {
      if (panels.length <= 1) {
        mobilePagination.style.display =
          'none';
      }
    }

    updateMobileIndicator(0);

    initializeImageRotations();

    syncMode();
  }

  function initAllTabShowcases(root) {
    const scope = root || document;

    if (
      scope.matches &&
      scope.matches(
        '[data-tab-showcase]'
      )
    ) {
      initTabShowcase(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll(
          '[data-tab-showcase]'
        )
        .forEach(
          initTabShowcase
        );
    }
  }

  if (
    !window.__tabShowcaseGlobalInit
  ) {
    window.__tabShowcaseGlobalInit =
      true;

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          initAllTabShowcases(
            document
          );
        },
        {
          once: true
        }
      );
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        initAllTabShowcases(
          event.target
        );
      }
    );
  }

  if (
    document.readyState !==
    'loading'
  ) {
    initAllTabShowcases(
      document
    );
  }
})();